export const PROSTAGLANDINS = { id: 'prostaglandins', label: 'Prostaglandine' };
export const OXYTOCIN = { id: 'oxytocin', label: 'Ossitocina' };
export const AMNIORRHEXIS = { id: 'amniorrhexis', label: 'Amnioressi' };
export const OTHER = { id: 'other', label: 'Altro farmaco/Altro metodo meccanico' };
